import {
    useCallback,
    useMemo,
} from 'react'

import Card from 'app/shared-components/Card'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import useCardForTableStyles from 'app/tss/cardForTable'
import useTableStyles from 'app/tss/table.styles'
import requestConfig from 'app/requests/Order/Order.requests'
import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import {
    OrderTypes,
} from 'app/enums/label.enums'
import useLinkStyles from 'app/tss/link.styles'

import inboundOrdersConfig from './inboundOrders.config'
import outboundOrdersConfig from './outboundOrder.config'

const RelatedOrders = ({
    id,
}: { id: number }) => {
    const {
        classes: cardClasses,
    } = useCardForTableStyles()
    const {
        classes: tableClasses,
    } = useTableStyles()
    const {
        classes: linkClasses,
    } = useLinkStyles()

    const {
        InternalOrders: InternalOrdersRoutes,
        CustomerOrders: CustomerOrdersRoutes,
    } = useOrderManagementRoutes()

    const getOrderLink = useCallback((orderNumber: string, orderType: OrderTypes) => {
        return generateSkyNetLink({
            domainPath: orderType === OrderTypes.CUSTOMER_TRANSPORT
                ? CustomerOrdersRoutes.Overview.path
                : InternalOrdersRoutes.Overview.path,
            params: {
                key: orderNumber,
            },
        })
    }, [
        CustomerOrdersRoutes.Overview.path,
        InternalOrdersRoutes.Overview.path,
    ])

    const outboundOrderTableConfig = useMemo(() => {
        return outboundOrdersConfig({
            getOrderLink,
            linkStyle: linkClasses.tableLink,
        })
    }, [
        getOrderLink,
        linkClasses.tableLink,
    ])
    const inboundOrderTableConfig = useMemo(() => {
        return inboundOrdersConfig(
            {
                getOrderLink,
                linkStyle: linkClasses.tableLink,
            },
        )
    }, [
        getOrderLink,
        linkClasses.tableLink,
    ])

    return (
        <>
            <Card
                className={cardClasses.root}
                title="Outbound Orders"
            >
                <SkyNetTable
                    name="RelatedOrders-OutboundOrder"
                    tableConfig={outboundOrderTableConfig}
                    customUrl={requestConfig.truckingCapacityOutbound().url}
                    simple
                    className={tableClasses.table}
                    filters={{
                        serviceCenterId: id,
                    }}
                    showSearch
                />
            </Card>
            <Card
                className={cardClasses.root}
                title="Inbound Orders"
            >
                <SkyNetTable
                    name="RelatedOrders-InboundOrder"
                    tableConfig={inboundOrderTableConfig}
                    customUrl={requestConfig.truckingCapacityInbound().url}
                    simple
                    className={tableClasses.table}
                    filters={{
                        serviceCenterId: id,
                    }}
                    showSearch
                />
            </Card>
        </>
    )
}

export default RelatedOrders
